/**
 * Values for converted wet density field preparation.compactiveeffort
 */
export enum CompactiveEffort {
  Standard = 'Standard',

  Modified = 'Modified',
}

export enum OversizePropertytoCalculate {
  Density = 'Density',

  Volume = 'Volume',
}
